import React from "react";
import {FormDialog, SelectElementModelFE} from "../../../api/types/generic";
import {FormAutocomplete} from "../../../common/form-fields";
import {useTranslation} from "react-i18next";
import {Chip} from "@mui/material";
import {darken, lighten, styled} from "@mui/system";
import {LocationGroupProductCodeModelFE} from "../../../api/types/locationGroupProductCode";

const GroupHeader = styled("div")(({theme}) => ({
    position: "sticky",
    top: "-8px",
    padding: "4px 10px",
    color: theme.palette.primary.main,
    backgroundColor:
        theme.palette.mode === "light"
            ? lighten(theme.palette.primary.light, 0.85)
            : darken(theme.palette.primary.main, 0.8)
}));

const GroupItems = styled("ul")({
    padding: 0
});

export default ({
                    nestIndex,
                    formDialog,
                    options,
                    handleChange,
                    name,
                    getValues
                }: {
    nestIndex: number,
    formDialog: FormDialog | null,
    options: any,
    handleChange: Function,
    name: string
    getValues: Function
}) => {
    // Use Translation
    const {t} = useTranslation(["translation", "pricing"]);

    return (
        <FormAutocomplete
            name={`associations.${nestIndex}.${name}`}
            label={`${t("pricing:exceptionListProductCodeLocationGroup.form.labels." + name)}`}
            options={options}
            isOptionEqualToValue={(option: SelectElementModelFE, value: SelectElementModelFE) => {
                return value?.code === option?.code;
            }}
            multiple={true}
            handleChange={(value: SelectElementModelFE[]) => handleChange(value, nestIndex)}
            readOnly={
                Boolean(
                    !getValues().associations[nestIndex].productCode
                    ||
                    getValues().associations[nestIndex].productCode?.length === 0
                ) ||
                Boolean(formDialog?.readonly) ||
                Boolean(formDialog?.inUse)
            }
            groupBy={(option) => (option as LocationGroupProductCodeModelFE).productCodeId}
            renderGroup={(params) => (
                <li>
                    <GroupHeader>{params.group}</GroupHeader>
                    <GroupItems>{params.children}</GroupItems>
                </li>
            )}
            getOptionDisabled={() =>
                getValues()?.associations[nestIndex]?.productCode?.length > 1
            }
            renderTags={
                getValues()?.associations[nestIndex]?.productCode?.length > 1 ?
                    (tagValue, getTagProps) => tagValue.map((option, index) => (
                        <Chip
                            label={option.label}
                            {...getTagProps({index})}
                            disabled={true}
                        />
                    ))
                    : undefined
            }
        />
    );
};
